import styled from 'styled-components';
import { device } from '../breakpoints';
import { fontWeightRegular } from '../design-tokens';
import PlayTag from '../PlayTag/PlayTag';
import { playFontSize, regularOutline } from '../typography/helpers';
import { ClearFix } from '../utils.styles';

export const A11yLinksList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    ${ClearFix};
    width: 100%;
    clear: both;
    margin-bottom: 20px;

    @media ${device.GteMedium} {
        margin-bottom: 30px;
    }
`;

export const A11yListItem = styled.li`
    float: left;
    margin-right: 10px;
`;

export const A11yLink = styled(PlayTag)`
    ${playFontSize(1.6)}
    display: block;
    margin: 1px 1em 3px 1px;
    text-decoration: underline;
    font-weight: ${fontWeightRegular};

    background: transparent;

    &:hover {
        cursor: pointer;
    }

    &:focus {
        ${regularOutline()}
    }
`;
